import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import AscAnimation from "../asc3d.gif";
import AscAnimation2 from "../asc3d1.gif";
import Button from "@mui/material/Button";

export default function SimpleBackdrop({ open, setOpen }) {
  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <img src={AscAnimation2} alt="Loading animation" />
        {/* <CircularProgress color="inherit" size={64} /> */}
      </Backdrop>
    </div>
  );
}
